<template>
  <section class="dp-layout screen-device-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
    </section>
    <section class="dp-right">
      <div v-if="!schoolId" class="no-data-tip">
        <i class="el-icon-school"></i>
        <p>请从左侧选择学校后再查看发布历史</p>
      </div>
      <div v-else class="content-wrapper config-panel">
        <el-card class="config-card">
          <div slot="header" class="card-header">
            <div class="title-wrap">
              <span class="title">大屏配置发布历史</span>
              <span v-if="schoolName" class="school-tag">当前学校：{{ schoolName }}</span>
            </div>
          </div>
          <div class="toolbar-filter-bar">
          <el-form :inline="true" class="toolbar-filter-form">
            <div class="toolbar-filter-fields">
            <el-form-item label="SN">
              <el-input v-model="sn" placeholder="输入SN筛选" clearable class="toolbar-field-w-xl" @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
            </div>
            <div class="toolbar-filter-actions">
              <el-button size="small" type="info" icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
            </div>
          </el-form>
          </div>
          <div class="tbl-scroll-host">
            <el-table :data="rows" v-loading="loading" height="100%" style="width: 100%">
            <el-table-column prop="Id" label="ID" />
            <el-table-column prop="Sn" label="SN" />
            <el-table-column prop="DeviceName" label="名称" min-width="120" show-overflow-tooltip />
            <el-table-column prop="ConfigVersion" label="版本号" />
            <el-table-column prop="OperateSource" label="来源" />
            <el-table-column prop="OperateBy" label="操作人" />
            <el-table-column prop="CreateTime" label="时间" width="180" />
            <el-table-column label="操作" width="140" align="center">
              <template slot-scope="scope">
                <div class="table-op-pair">
                  <el-button type="text" size="small" class="table-op-link" @click="openDetail(scope.row)">详情</el-button>
                  <el-button type="text" size="small" class="table-op-link table-op-link--danger" @click="removeHistory(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
            </el-table>
          </div>
          <div class="pagination-wrap">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page.sync="page"
              :page-size.sync="pageSize"
              :page-sizes="[10, 20, 50]"
              :total="total"
              @size-change="onPageSizeChange"
              @current-change="onPageChange">
            </el-pagination>
          </div>
        </el-card>
      </div>

      <el-dialog title="发布记录详情" :visible.sync="detailVisible" :width="detailDialogWidth">
        <el-descriptions :column="detailDescColumn" border size="small" class="detail-meta-descriptions" style="margin-bottom: 12px">
          <el-descriptions-item label="SN">{{ detailRow.Sn || "-" }}</el-descriptions-item>
          <el-descriptions-item label="名称">{{ detailRow.DeviceName || "-" }}</el-descriptions-item>
          <el-descriptions-item label="版本号">{{ detailRow.ConfigVersion || "-" }}</el-descriptions-item>
          <el-descriptions-item label="来源">{{ detailRow.OperateSource || "-" }}</el-descriptions-item>
          <el-descriptions-item label="操作人">{{ detailRow.OperateBy || "-" }}</el-descriptions-item>
          <el-descriptions-item label="时间" :span="detailTimeSpan">{{ detailRow.CreateTime || "-" }}</el-descriptions-item>
        </el-descriptions>
        <el-table :data="detailCompareRows" border size="small" style="width: 100%">
          <el-table-column prop="label" label="字段" width="140" />
          <el-table-column label="变更前">
            <template slot-scope="scope">
              <template v-if="scope.row.fieldKey === 'ScreenUrl' && isValidHttpUrl(scope.row.beforeRaw)">
                <el-link type="primary" :underline="false" @click="openPreview(scope.row.beforeRaw)">
                  {{ scope.row.beforeText }}
                </el-link>
              </template>
              <span v-else :class="{ 'changed-text': scope.row.changed }">{{ scope.row.beforeText }}</span>
            </template>
          </el-table-column>
          <el-table-column label="变更后">
            <template slot-scope="scope">
              <template v-if="scope.row.fieldKey === 'ScreenUrl' && isValidHttpUrl(scope.row.afterRaw)">
                <el-link type="primary" :underline="false" @click="openPreview(scope.row.afterRaw)">
                  {{ scope.row.afterText }}
                </el-link>
              </template>
              <span v-else :class="{ 'changed-text': scope.row.changed }">{{ scope.row.afterText }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { getScreenConfigHistoryAdmin, deleteScreenConfigHistoryAdmin } from '../../api/modules/misc';
import DepartmentPane from "@/components/DepartmentPane.vue";

export default {
  name: "ScreenDeviceManageConfigHistory",
  components: { DepartmentPane },
  data() {
    return {
      schoolId: 0,
      schoolName: "",
      loading: false,
      sn: "",
      rows: [],
      page: 1,
      pageSize: 10,
      total: 0,
      detailVisible: false,
      detailRow: {},
      detailCompareRows: [],
      layoutViewportWidth: typeof window !== "undefined" ? window.innerWidth : 1200
    };
  },
  computed: {
    detailDialogWidth() {
      const w = this.layoutViewportWidth;
      if (w <= 600) {
        return "98%";
      }
      if (w <= 960) {
        return "94%";
      }
      return "980px";
    },
    detailDescColumn() {
      const w = this.layoutViewportWidth;
      if (w <= 600) {
        return 1;
      }
      if (w <= 900) {
        return 2;
      }
      return 3;
    },
    detailTimeSpan() {
      return this.detailDescColumn <= 1 ? 1 : 2;
    }
  },
  mounted() {
    this._onLayoutResize = this.debounceLayoutResize(() => {
      this.layoutViewportWidth = window.innerWidth;
    }, 120);
    window.addEventListener("resize", this._onLayoutResize, { passive: true });
  },
  beforeDestroy() {
    if (this._onLayoutResize) {
      window.removeEventListener("resize", this._onLayoutResize);
    }
  },
  methods: {
    debounceLayoutResize(fn, delay) {
      let timer = null;
      return function wrapped() {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          timer = null;
          fn();
        }, delay);
      };
    },
    treeNodeClick(node) {
      this.schoolId = Number(node && node.value ? node.value : 0);
      this.schoolName = node && node.label ? node.label : "";
      this.page = 1;
      this.loadData();
    },
    handleQuery() {
      this.page = 1;
      this.loadData();
    },
    handleReset() {
      this.sn = "";
      this.page = 1;
      this.loadData();
    },
    onPageChange(page) {
      this.page = page;
      this.loadData();
    },
    onPageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.loadData();
    },
    async loadData() {
      if (!this.schoolId) {
        this.rows = [];
        this.total = 0;
        return;
      }
      this.loading = true;
      try {
        const res = await getScreenConfigHistoryAdmin({
          schoolId: this.schoolId,
          sn: this.sn || "",
          page: this.page,
          pageSize: this.pageSize
        });
        if (res.data.success) {
          const payload = res.data.response;
          if (payload && Array.isArray(payload.data)) {
            this.rows = payload.data;
            this.total = payload.dataCount || 0;
            if (payload.page) this.page = payload.page;
            if (payload.PageSize) this.pageSize = payload.PageSize;
          } else if (Array.isArray(payload)) {
            // 兼容旧接口（全量列表）
            this.rows = payload;
            this.total = payload.length;
          } else {
            this.rows = [];
            this.total = 0;
          }
        } else {
          this.$message.error(res.data.msg || "加载失败");
        }
      } finally {
        this.loading = false;
      }
    },
    openDetail(row) {
      this.detailRow = row || {};
      const beforeObj = this.parseJsonObject(row ? row.BeforeJson : "");
      const afterObj = this.parseJsonObject(row ? row.AfterJson : "");
      this.detailCompareRows = this.buildCompareRows(beforeObj, afterObj);
      this.detailVisible = true;
    },
    async removeHistory(row) {
      await this.$confirm(`确认删除历史记录 ID=${row.Id} 吗？`, "提示", {
        type: "warning"
      });
      const res = await deleteScreenConfigHistoryAdmin({ id: row.Id });
      if (res.data.success) {
        this.$message.success(res.data.msg || "删除成功");
        if (this.rows.length <= 1 && this.page > 1) {
          this.page -= 1;
        }
        this.loadData();
      } else {
        this.$message.error(res.data.msg || "删除失败");
      }
    },
    parseJsonObject(jsonText) {
      if (!jsonText) {
        return {};
      }
      try {
        return JSON.parse(jsonText);
      } catch (e) {
        return { _raw: jsonText };
      }
    },
    buildCompareRows(beforeObj, afterObj) {
      const fields = [
        { key: "Sn", label: "SN" },
        { key: "ConfigVersion", label: "版本号" },
        { key: "DisplayState", label: "启用状态" },
        { key: "ScreenUrl", label: "地址" },
        { key: "DurationSec", label: "展示时长（预留）" },
        { key: "ExtraJson", label: "扩展信息" },
        { key: "LastHeartbeatTime", label: "最近心跳" },
        { key: "ModifyTime", label: "修改时间" }
      ];
      const rows = fields.map((field) => {
        const beforeText = this.getFieldText(field.key, beforeObj[field.key]);
        const afterText = this.getFieldText(field.key, afterObj[field.key]);
        return {
          label: field.label,
          fieldKey: field.key,
          beforeRaw: beforeObj[field.key],
          afterRaw: afterObj[field.key],
          beforeText,
          afterText,
          changed: beforeText !== afterText
        };
      });
      if (beforeObj._raw || afterObj._raw) {
        rows.push({
          label: "原始JSON",
          beforeText: beforeObj._raw || "-",
          afterText: afterObj._raw || "-",
          changed: (beforeObj._raw || "-") !== (afterObj._raw || "-")
        });
      }
      return rows;
    },
    getFieldText(fieldKey, value) {
      if (value === null || value === undefined || value === "") {
        if (fieldKey === "DurationSec") {
          return "0 秒（不限时）";
        }
        return "-";
      }
      if (fieldKey === "DisplayState") {
        return this.getDisplayStateText(value);
      }
      if (fieldKey === "DurationSec") {
        const durationSec = Number(value || 0);
        return durationSec <= 0 ? "0 秒（不限时）" : `${durationSec} 秒`;
      }
      if (fieldKey === "ModifyTime" || fieldKey === "LastHeartbeatTime") {
        return this.formatDateTime(value);
      }
      if (fieldKey === "ExtraJson" && typeof value === "object") {
        return JSON.stringify(value);
      }
      return String(value);
    },
    isValidHttpUrl(url) {
      if (!url || typeof url !== "string") {
        return false;
      }
      try {
        const parsed = new URL(url);
        return parsed.protocol === "http:" || parsed.protocol === "https:";
      } catch (e) {
        return false;
      }
    },
    openPreview(url) {
      if (!this.isValidHttpUrl(url)) {
        this.$message.warning("地址格式不合法，无法预览");
        return;
      }
      window.open(url, "_blank");
    },
    formatDateTime(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      const text = String(value);
      const needNormalize = text.includes("T") || text.includes("Z") || /[+-]\d{2}:\d{2}$/.test(text) || text.includes(".");
      if (!needNormalize) {
        return text;
      }
      const date = new Date(text);
      if (Number.isNaN(date.getTime())) {
        return text;
      }
      const pad = (num) => String(num).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}:${pad(date.getSeconds())}`;
    },
    getDisplayStateText(displayState) {
      const map = {
        playing: "展示中",
        closed: "已关闭",
        cleared: "已清空"
      };
      return map[displayState] || String(displayState);
    }
  }
};
</script>

<style lang="stylus" scoped>
.screen-device-page.dp-layout
  height 100%
  box-sizing border-box
  padding 12px 16px
  @media (max-width: 768px)
    flex 1
    min-height 0
    flex-direction column
    align-items stretch
    padding 12px
    .dp-left
      width 100% !important
      max-width 100%
      margin-right 0 !important
      margin-bottom 12px
      max-height 280px
      flex-shrink 0
    .dp-right
      width 100%
      min-width 0 !important
      flex 1
      min-height 0
.screen-device-page .dp-right
  display flex
  flex-direction column
  min-width 0
  min-height 0
  overflow hidden
  padding 12px 14px
.screen-device-page .dp-right > .content-wrapper
  flex 1
  min-height 0
  overflow hidden
  display flex
  flex-direction column
  gap 10px
  width 100%
  max-width 100%
  box-sizing border-box
.config-panel
  max-width 1200px
  margin 0 auto
  width 100%
  box-sizing border-box
  @media (max-width: 768px)
    max-width 100%
    margin 0
.config-card
  flex 1
  min-width 0
  min-height 0
  width 100%
  box-sizing border-box
  display flex
  flex-direction column
  overflow hidden
  border-radius 8px
  border none
  box-shadow 0 2px 12px 0 rgba(0, 0, 0, 0.05)
  >>> .el-card__header
    flex-shrink 0
    padding 10px 14px
  >>> .el-card__body
    flex 1
    min-width 0
    min-height 0
    overflow hidden
    display flex
    flex-direction column
    padding 12px 14px 16px
.tbl-scroll-host
  flex 1 1 auto
  min-height 0
  height 0
  width 100%
  overflow hidden
.no-data-tip
  flex 1
  display flex
  flex-direction column
  align-items center
  justify-content center
  color #c0c4cc
  i
    font-size 48px
    margin-bottom 12px
.school-tag
  margin-left 12px
  font-size 12px
  color #909399
  flex-shrink 1
  min-width 0
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
.card-header
  display flex
  align-items center
  justify-content space-between
  padding 0
  min-height 0
  flex-wrap wrap
  gap 8px
  row-gap 8px
.title-wrap
  display flex
  align-items center
  flex 1
  min-width 0
  flex-wrap wrap
  gap 6px 12px
.title
  font-size 16px
  font-weight 600
  color #303133
  border-left 4px solid #2563eb
  padding-left 10px
  line-height 1.3
  flex-shrink 0

.actions
  display flex
  align-items center
  gap 8px

.pagination-wrap
  flex-shrink 0
  margin-top 12px
  display flex
  justify-content flex-end

@media (max-width: 768px)
  .screen-device-page .dp-right > .content-wrapper
    overflow visible
    height auto
  .tbl-scroll-host
    height auto
    flex none
    overflow visible

.detail-meta-descriptions
  width 100%
  min-width 0
  >>> table.el-descriptions__table
    table-layout fixed
    width 100% !important

.changed-text
  color #2563eb
  font-weight 600
</style>
